'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var react = require('@chakra-ui/react');
var dateTimeFieldContext = require('../dateTimeFieldContext.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var _excluded = ["placeholderFormat"],
  _excluded2 = ["placeholderFormat"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty__default["default"](target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
/**
 * Takes normalized `TimePickerProps` and returns the original props.
 */
function useNormalizedTimeFieldProps(props) {
  var placeholderFormat = props.placeholderFormat,
    rest = _objectWithoutProperties__default["default"](props, _excluded);
  var normalized = _objectSpread({}, placeholderFormat && {
    placeholderValue: placeholderFormat
  });
  return _objectSpread(_objectSpread({}, rest), normalized);
}

/**
 * Takes normalized `DatePickerProps` and returns the original props.
 */
function useNormalizedDateFieldProps(props) {
  var placeholderFormat = props.placeholderFormat,
    rest = _objectWithoutProperties__default["default"](props, _excluded2);
  var normalized = _objectSpread({}, placeholderFormat && {
    placeholderValue: placeholderFormat
  });
  return _objectSpread(_objectSpread({}, rest), normalized);
}

/**
 * Takes `UseDateSegmentProps` and `DateSegmentAria` props and returns normalized props.
 *
 * @param segment - The segment to render.
 * @param segmentProps - The props returned from `useDateSegment`.
 */
function useNormalizedDateSegmentProps(segment, segmentProps) {
  var _segmentProps$ariaLa;
  var context = dateTimeFieldContext.useDateTimeFieldContext();
  var formControlContext = react.useFormControlContext();
  var normalized = _objectSpread(_objectSpread({}, !!(formControlContext !== null && formControlContext !== void 0 && formControlContext.id) && {
    id: "".concat(formControlContext.id, "-segment-").concat(context.state.segments.indexOf(segment) + 1)
  }), segmentProps['aria-labelledby'] && {
    'aria-labelledby': (_segmentProps$ariaLa = segmentProps['aria-labelledby']) === null || _segmentProps$ariaLa === void 0 ? void 0 : _segmentProps$ariaLa.split(' ').filter(function (id) {
      return !id.includes('react-aria');
    }).join(' ')
  });
  return _objectSpread(_objectSpread({}, segmentProps), normalized);
}
exports.useNormalizedDateFieldProps = useNormalizedDateFieldProps;
exports.useNormalizedDateSegmentProps = useNormalizedDateSegmentProps;
exports.useNormalizedTimeFieldProps = useNormalizedTimeFieldProps;